import React from 'react';
import ActionItems from 'Components/UI/ActionItems';
import { Box, makeStyles } from '@material-ui/core';
import useUserContext from 'Context/UserContext';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 2),
    backgroundColor: theme.palette.facet.lightGray,
  },
  container: {
    maxWidth: theme.dimensions.xxl,
    margin: 'auto',
  },
}));

export default function ClientActionItems(props) {
  const classes = useStyles();
  const { isAgent } = useUserContext();
  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        <ActionItems readOnly={isAgent} displayAdvisorTasks={false} {...props} />
      </Box>
    </Box>
  );
}
